import { useId } from "react";
import { useField } from "formik";

export default function Select({ label, field, children, hint, className = "", form: _form, meta: _meta, as: _as, component: _component, ...props }) {
  const [formikField, meta] = useField(props.name || field?.name);
  const uniqueId = useId();
  const id = props.id || `${props.name || field?.name || "select"}-${uniqueId}`;
  const hasError = meta.touched && meta.error;
  const messageId = `${id}-message`;
  return (
    <div className="min-w-0">
      {label && <label htmlFor={id} className="block mb-2 text-sm font-medium text-slate-700 dark:text-slate-200">{label}</label>}
      <select {...formikField} {...field} {...props} id={id} aria-invalid={hasError ? true : undefined} aria-describedby={hasError || hint ? messageId : undefined} className={`admin-field block w-full ${className}`}>{children}</select>
      {hasError ? <p id={messageId} role="alert" className="admin-field-error">{meta.error}</p> : hint ? <p id={messageId} className="admin-field-hint">{hint}</p> : null}
    </div>
  );
}
